/** Склонение по числу: plural(3, "гейт", "гейта", "гейтов") → "гейта".
 *  Исключение 11–14 всегда third form. Зеркало text.Plural на бэкенде. */
export function plural(n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(Math.trunc(n));
  const mod100 = abs % 100;
  if (mod100 >= 11 && mod100 <= 14) return many;
  const mod10 = abs % 10;
  if (mod10 === 1) return one;
  if (mod10 >= 2 && mod10 <= 4) return few;
  return many;
}

/** Число и слово: count(3, "гейт", "гейта", "гейтов") → "3 гейта". */
export function count(n: number, one: string, few: string, many: string): string {
  return `${n} ${plural(n, one, few, many)}`;
}
